export default "__VITE_ASSET__C$y2g_6M__"